import React, { useState, useEffect, useReducer } from "react";
import getData from "../Custome_Components/commonAPISelect";
import Loading from "../Custome_Components/Loading";
import ModalLoading from '../Custome_Components/ModalLoading';
import ExportTableToExcel from "../Custome_Components/ExportTableToExcel";
import DataTable from '../Custome_Components/DataTable';
import RaiseTicket from "./raiseTicket";
import View from "./Views/View";
import supportImg from '../Assets/img/RTimg1.png';
import salesImg from '../Assets/img/RTimg2.png';
import billingImg from '../Assets/img/RTimg3.png';
import { IoMdRefresh } from "react-icons/io";
import { IoSearchOutline } from "react-icons/io5";
import Button from '@mui/material/Button';
import { IoCloseOutline } from "react-icons/io5";
import { LuFilter } from "react-icons/lu";
import { toast } from "react-toastify";
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import Popover from '@mui/material/Popover';
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        fontSize: '14px',
    },
}));

const FilterReducer = (state, action) => {
    switch (action.type) {
        case "StageIDPK":
            return { ...state, StageIDPK: action.payload };
        case "StageName":
            return { ...state, StageName: action.payload };
        case "FromDate":
            return { ...state, FromDate: action.payload };
        case "ToDate":
            return { ...state, ToDate: action.payload };
        default:
            return state;
    }
};

const initialState = {
    StageIDPK: null,
    StageName: 'Total',
    FromDate: '',
    ToDate: ''
}

function Track() {
    const [state, dispatch] = useReducer(FilterReducer, initialState);
    const [searchTerm, setSearchTerm] = useState("");
    const [TableData, setTableData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [raiseTicketOpen, setRaiseTicketOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [Modalloading, setModalLoading] = useState(false);
    const [ViewModalOpen, setViewModalOpen] = useState(false);
    const [SelectedRowData, setSelectedRowData] = useState({});
    const [anchorElFilter, setAnchorElFilter] = useState(null);
    const [isDepartmentOpen, setIsDepartmentOpen] = useState(false);
    const [ActiveStage, setActiveStage] = useState('Total');
    const [filteredValue, setFilteredValue] = useState({
        stageid: null,
        stagename: 'Total',
        fromdate: '',
        todate: ''
    })
    const stageList = [
        { id: null, name: 'Total' },
        { id: 1, name: 'Raised' },
        { id: 2, name: 'Acknowledged' },
        { id: 3, name: 'In Progress' },
        { id: 4, name: 'Closed' }
    ];

    const [filterModel, setFilterModel] = useState({
        items: [],
    });

    const visibleRows = filteredData.filter((row) => {
        return filterModel.items.every((filter) => {
            if (!filter.value) return true;

            const cellValue = row[filter.field];

            return String(cellValue ?? '')
                .toLowerCase()
                .includes(filter.value.toLowerCase());
        });
    });

    useEffect(() => { handleTrackTable() }, [])

    useEffect(() => {
        const filtered = TableData.filter((row) =>
            Object.values(row).some((value) =>
                value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setFilteredData(filtered);
    }, [searchTerm, TableData]);

    const reduceColorOpacity = (color, opacity = 0.1) => {
        if (!color) return '#0000007a';

        if (color.startsWith('rgb')) {
            const rgbValues = color.match(/\d+/g);
            return `rgba(${rgbValues[0]}, ${rgbValues[1]}, ${rgbValues[2]}, ${opacity})`;
        }

        if (color.startsWith('#')) {
            const hex = color.replace('#', '');
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            return `rgba(${r}, ${g}, ${b}, ${opacity})`;
        }

        return color;
    };

    const handleRefresh = () => {
        handleTrackTable();
    }

    const handleViewModalClose = () => {
        setViewModalOpen(false);
        setSelectedRowData([]);
        handleRefresh();
    }

    const handleRTopen = () => setRaiseTicketOpen(true);
    const handleRTclose = () => { setRaiseTicketOpen(false); handleTrackTable() }

    const handleValidation = () => {
        if (!state.StageName) {
            toast.warning("Kindly select the 'stage'");
            return;
        } else if (state.FromDate && !state.ToDate) {
            toast.warning("Kindly select the 'To Date'");
            return;
        } else if (state.ToDate && !state.FromDate) {
            toast.warning("Kindly select the 'From Date'");
            return;
        }
        handleTrackTable();
    }

    const handleTrackTable = async () => {
        setLoading(true);
        const response = await getData("VwAPINSEIPLClientPortal/", {
            data: {
                p1_int: 5,
                p5_int: state.StageIDPK ?? null,
                p9_varchar: state.FromDate ?? null,
                p10_varchar: state.ToDate ?? null,
                UserID_int: localStorage.getItem("EmpID")
            },
        });
        const { Output: { status, data } } = response;
        if (response.Output.status.code == "200") {
            const formattedRows = response?.Output?.data?.map((item, index) => ({
                id: index + 1,
                ...item
            }));
            setTableData(formattedRows || []);
            setLoading(false);
            setActiveStage(state.StageName);
            setAnchorElFilter(null);
            setFilteredValue({
                stageid: state.StageIDPK,
                stagename: state.StageName,
                fromdate: state.FromDate,
                todate: state.ToDate,
            })
        } else {
            console.error("Error fetching data:", status.message);
            setLoading(false);
        }
    };

    const userColumns = [
        {
            field: 'ComplaintNo', headerName: 'Complaint No', width: 120,
            renderCell: (params) => (
                <span className='ticketNoStyle'>
                    {params.value}
                </span>),
        },
        { field: 'PortalSubject', headerName: 'Subject', width: 250 },
        { field: 'RequestDetailsDesc', headerName: 'Description', width: 300 },
        { field: 'ComplainedDate', headerName: 'Date', width: 120 },
        {
            field: 'StageName', headerName: 'Stage', width: 120,
            renderCell: ({ value, row }) => {
                return (
                    <span
                        className="RaisedRowStatusStyle"
                        style={{
                            color: row.PortalColour,
                            backgroundColor: reduceColorOpacity(row.PortalColour)
                        }}>{value}</span>
                );
            },
        },
        {
            field: 'PriorityName', headerName: 'Priority', width: 120,
            renderCell: ({ value, row }) => {
                return (
                    <span
                        className="RaisedRowStatusStyle"
                        style={{
                            color: value.toLowerCase() === 'low' ? '#679436' :
                                value.toLowerCase() === 'medium' ? '#1976d2' :
                                    value.toLowerCase() === 'high' ? '#d90429' :
                                        value.toLowerCase() === 'critical' ? '#fff' : null,
                            backgroundColor: reduceColorOpacity(value.toLowerCase() === 'low' ? '#6794361a' :
                                value.toLowerCase() === 'medium' ? '#1976d236' :
                                    value.toLowerCase() === 'high' ? '#d904291a' :
                                        value.toLowerCase() === 'critical' ? 'red' : null)
                        }}>{value}</span>
                );
            },
        },
        {
            field: 'PortalDepartment', headerName: 'Stage Name', width: 150,
            renderCell: (params) => {
                return (
                    <span className="DepartmentRowStyle">
                        <img src={(params.value && params.value.toLowerCase() === 'support') ? supportImg :
                            (params.value && params.value.toLowerCase() === 'sales') ? salesImg :
                                (params.value && params.value.toLowerCase() === 'billing') ? billingImg : ''} className="DepartmentRowImgSty" alt="logo" />
                        {params.value} </span>);
            }
        },
        { field: 'ClientReqName', headerName: 'Request Type', width: 150 },
        { field: 'ClentOthersRemarks', headerName: 'Request Remarks', width: 300 },
        { field: 'TaskStatusName', headerName: 'Task Status', width: 150 },
        {
            field: 'ClientTestName', headerName: 'Client Status', width: 150,
            renderCell: (params) => {
                return (
                    <>
                        {params.value && <span className={params.value == "Pass" ? "PassRowStatusStyle" :
                            params.value == "Fail" ? "FailRowStatusStyle" :
                                params.value == "Discussion" ? "DiscussionRowStatusStyle" :
                                    params.value == "ReTest" ? "RetestRowStatusStyle" : null
                        }>{params.value}</span>}
                    </>);
            }
        },
        { field: 'ReqName', headerName: 'Requestor Name', width: 150 },
        { field: 'Email', headerName: 'Email', width: 150 },
        { field: 'PhoneNo', headerName: 'Contact Number', width: 150 },
        { field: 'ResonForPending', headerName: 'Activity Remarks', width: 300 },
    ];

    const columnsConfig = [
        { label: 'Ticket No', value: 'ComplaintNo' },
        { label: 'Subject', value: 'PortalSubject' },
        { label: 'Description', value: 'RequestDetailsDesc' },
        { label: 'Date', value: 'ComplainedDate' },
        { label: 'Stage', value: 'StageName' },
        { label: 'StageName', value: 'PortalDepartment' },
        { label: 'Request Type', value: 'ClientReqName' },
        { label: 'Request Remarks', value: 'ClentOthersRemarks' },
        { label: 'Task Status', value: 'TaskStatusName' },
        { label: 'Client Status', value: 'ClientTestName' },
        { label: 'Requestor Name', value: 'ReqName' },
        { label: 'Email', value: 'Email' },
        { label: 'Contact Number', value: 'ResoPhoneNonForPending' },
        { label: 'Activity Remarks', value: 'ResonForPending' }
    ];

    return (
        <div style={{ width: "100%", height: "100%" }}>
            <Loading loading={loading}>
                <div className="TablePageParent">
                    <div className="TableHeadingSection">

                        <div className="TableTabSection">
                            <span className="AbstractCount">
                                {ActiveStage ?? 'Total'} - {`(${visibleRows.length})`}
                            </span>
                            {filteredValue.fromdate.length > 0 &&
                                <div className="FilterdAbstractSec">
                                    <div>
                                        <span className="FilterLabel">From Date:</span>
                                        <span className="FilterValue">{filteredValue.fromdate ?? '-'}</span>
                                    </div>
                                    <div>
                                        <span className="FilterLabel">To Date:</span>
                                        <span className="FilterValue">{filteredValue.todate ?? '-'}</span>
                                    </div>
                                </div>}
                        </div>

                        <div className="TableSearchSection">
                            <BootstrapTooltip title={"Refresh"} placement="top">
                                <div className="WeeklyTaskRefreshParent" onClick={handleRefresh}>
                                    <IoMdRefresh className="WeeklyRefreshIcon" />
                                </div>
                            </BootstrapTooltip>

                            <BootstrapTooltip title={"Filter"} placement="top">
                                <div className="WeeklyTaskRefreshParent" style={{ padding: "0px 9px" }}
                                    onClick={(e) => {
                                        dispatch({ type: 'StageIDPK', payload: filteredValue.stageid });
                                        dispatch({ type: 'StageName', payload: filteredValue.stagename });
                                        dispatch({ type: 'FromDate', payload: filteredValue.fromdate });
                                        dispatch({ type: 'ToDate', payload: filteredValue.todate });
                                        setAnchorElFilter(e.currentTarget)
                                    }}>
                                    <LuFilter className="FilterIcon" />
                                </div>
                            </BootstrapTooltip>

                            <Popover
                                id={Boolean(anchorElFilter) ? 'simple-popover' : undefined}
                                open={Boolean(anchorElFilter)}
                                anchorEl={anchorElFilter}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                                style={{ marginTop: "6px", right: "30px" }}
                            >
                                <div className="DashboardFilterPopoverDiv" >
                                    <div className="DashboardFilterHeadDiv">
                                        <h3 className="DbFilterHeadTxt">Filter</h3>
                                        <IoCloseOutline className="IoCloseStyle"
                                            onClick={() => setAnchorElFilter(null)} />
                                    </div>

                                    <div className="DbFilterDropdownParent">
                                        <div className="FilterInputFieldFullDiv">
                                            <span className="FilterInputLabel">Stages<span style={{ color: 'red', marginLeft: '2px' }}>*</span></span>
                                            <div className="dropdown InputFieldMainDiv" style={{ position: 'relative' }}>
                                                <input
                                                    type="text"
                                                    value={state.StageName}
                                                    onChange={(e) => {
                                                        dispatch({ type: 'StageName', payload: e.target.value });
                                                        dispatch({ type: 'StageName', payload: e.target.value });
                                                        setIsDepartmentOpen(true);
                                                    }}
                                                    onClick={() => setIsDepartmentOpen((prevState) => !prevState)}
                                                    placeholder="Select Stage"
                                                    className='SelectEmpInput'
                                                />

                                                {isDepartmentOpen ? <IoIosArrowUp className='RSslectArrowIcon' /> :
                                                    <IoIosArrowDown className='RSslectArrowIcon' />}

                                                {state.StageName && (
                                                    <IoCloseOutline onClick={() => {
                                                        setIsDepartmentOpen(false);
                                                        dispatch({ type: 'StageIDPK', payload: '' });
                                                        dispatch({ type: 'StageName', payload: '' });
                                                    }}
                                                        className='RSslectClearIcon' />)}

                                                {isDepartmentOpen && (
                                                    <div
                                                        className="SelectEmpDropDown"
                                                    >
                                                        {stageList.length > 0 ? (
                                                            stageList.map((item) => (
                                                                <div
                                                                    key={item.id}
                                                                    onClick={() => {
                                                                        dispatch({ type: 'StageIDPK', payload: item.id });
                                                                        dispatch({ type: 'StageName', payload: item.name });
                                                                        setIsDepartmentOpen(false);
                                                                    }}
                                                                    className='SelectEmpDropDownList'
                                                                >
                                                                    {item.name}
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div style={{ padding: '10px' }}>No results</div>
                                                        )}

                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="FilterInputField50Div">
                                            <span className="FilterInputLabel">From Date
                                                {state.ToDate && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
                                            </span>
                                            <div className="InputFieldMainDiv">
                                                <input
                                                    type="date"
                                                    className="RTDateInputField"
                                                    value={state.FromDate}
                                                    onChange={(e) => dispatch({ type: "FromDate", payload: e.target.value })}
                                                    max={state.ToDate || undefined}
                                                />
                                            </div>
                                        </div>

                                        <div className="FilterInputField50Div">
                                            <span className="FilterInputLabel">To Date
                                                {state.FromDate && <span style={{ color: 'red', marginLeft: '2px' }}>*</span>}
                                            </span>
                                            <div className="InputFieldMainDiv">
                                                <input
                                                    type="date"
                                                    className="RTDateInputField"
                                                    value={state.ToDate}
                                                    onChange={(e) => dispatch({ type: "ToDate", payload: e.target.value })}
                                                    min={state.FromDate || undefined}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="DbFilterBtnSecParent">
                                        <Button className="DashboardPrintBtn" onClick={handleValidation}>Apply</Button>
                                    </div>
                                </div>
                            </Popover>

                            <ExportTableToExcel tableData={visibleRows} columnConfig={columnsConfig} fileName={`${state.StageName} Lists`} />

                            <div className="TableSearchInputDiv">
                                <input
                                    type="text"
                                    placeholder="Search here"
                                    className="TableSerFil"
                                    value={searchTerm}
                                    onChange={(Event) => setSearchTerm(Event.target.value)}
                                />
                                <IoSearchOutline className="FaSearchTableStyle" />
                            </div>

                            <Button variant="contained"
                                sx={{
                                    fontSize: "13px",
                                    textTransform: "capitalize",
                                    height: "32px",
                                    letterSpacing: "0.6px !important",
                                    backgroundColor: "#0F4495",
                                    borderRadius: "4px",
                                    boxShadow: "none"
                                }}
                                onClick={handleRTopen}
                            >
                                Create a Ticket</Button>
                        </div>
                    </div>

                    <div className="TableParentDiv">
                        <DataTable
                            rows={filteredData}
                            columns={userColumns}
                            pageSize={10}
                            height={500}
                            onRowDoubleClick={(params) => {
                                setSelectedRowData(params.row);
                                setViewModalOpen(true);
                            }}
                            filterModel={filterModel}
                            setFilterModel={setFilterModel}
                            enableRowHover={true}
                        />
                    </div>
                </div>
            </Loading>

            <Modal
                open={raiseTicketOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="ModalParentStyle"
            >
                <div className="RTmodalParentDiv">
                    <RaiseTicket handleRTclose={handleRTclose} />
                </div>
            </Modal>

            <Modal
                open={ViewModalOpen}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                className="ModalParentStyle"
            >
                <div className="ViewModalParent">
                    <ModalLoading loading={Modalloading}>
                        <View handleViewModalClose={handleViewModalClose} Data={SelectedRowData} Modalloading={(e) => { setModalLoading(e) }} />
                    </ModalLoading>
                </div>
            </Modal>

        </div>

    )
}

export default Track;